import { render, staticRenderFns } from "./AdminSalesList.vue?vue&type=template&id=2f6e06ef"
import script from "./AdminSalesList.vue?vue&type=script&lang=js"
export * from "./AdminSalesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports